import React from 'react'
import Header from './Header'
import HomeHeader from './HomeHeader'
import SigninHeader from 'Components/Account/SigninHeader'
import Footer from './Footer'
import { useParams } from 'react-router-dom'
import HowItWorksAttorneyClient from './HowItWorksAttorneyClient'
import HowitworksAttorneyAssistant from './HowitworksAttorneyAssistant'

function HowItWorks() {
const {role} = useParams();
const builder = () => {
  switch(role) {
    case "1":
      return <HowItWorksAttorneyClient/>;
    case "2":
      return <HowItWorksAttorneyClient/>;
    case "3":
      return <HowitworksAttorneyAssistant/>
    default:
      return <div className='text-center'>How it works</div>;
}
}
  return (
    <div className='w-full h-full  '>
       <SigninHeader/>
       <div className=''>
        {builder()}
       </div>
       <Footer/>
    </div>
  )
}

export default HowItWorks
